import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Token } from '../../../shared/models/user.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) {}

  isUserLoggedIn(): boolean {
    return this.checkToken();
  }

  private checkToken(): boolean {
    let validToken = false;
    const stringToken = localStorage.getItem('tokenUser');
    const idCliente = localStorage.getItem('idCliente');

    if (stringToken !== null && idCliente !== null) {
      const token = JSON.parse(stringToken);
      if (token.access_token && token.expires_in) {
        const now = moment();
        const dateExpired = moment(token.dateExpired);

        if (now.isBefore(dateExpired)) {
          validToken = true;
        } else {
          validToken = false;
        }
      } else {
        validToken = false;
      }
    } else {
      validToken = false;
    }

    return validToken;
  }

  getAccessToken(): string {
    const stringToken = localStorage.getItem('tokenUser');
    let accessToken = '';

    if (stringToken !== null) {
      const token = JSON.parse(stringToken);
      accessToken = token.access_token;
    }

    return accessToken;
  }

  private saveToken(token: Token): void {
    let now = moment();
    let dateExpired = now.toDate().getTime() + token.expires_in;
    token.dateExpired = dateExpired;
    let idCliente = token.IDCliente;

    const tokenString = JSON.stringify(token);
    localStorage.setItem('tokenUser', tokenString);
    localStorage.setItem('idCliente', String(idCliente));
  }

  logout(): void {
    localStorage.removeItem('tokenUser');
    localStorage.removeItem('idCliente');
  }

  login(email: string, password: string, fk_entity: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        email: email,
        password: password,
        grant_type: 'password',
        fk_entity: fk_entity,
      };
      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/area-clientes-login',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            this.saveToken(response);
            observer.next(true);
          },
          (err) => {
            //TODO: Mejorar error de login
            console.log('error login', err);
            observer.error(err);
          }
        );
    });
  }
}
